/**
 * The two option lists shared by Create Quote and the quote/invoice edit page.
 *
 * They were written out twice, verbatim, in both files. That is the kind of
 * duplication that stays correct right up until someone adds a discount tier
 * in one place — so the list lives here and both read it.
 *
 * Values stay STRINGS. `discountPercent` is compared and stored as a string
 * everywhere downstream, and a dropdown hands back a string regardless, so
 * declaring them as numbers here would only invite a `===` that never matches.
 */

export const QUOTE_STATUS_OPTIONS = [
  { value: "Active", label: "Active" },
  { value: "Expired", label: "Expired" },
  { value: "Invoiced", label: "Invoiced" },
];

export const DISCOUNT_PERCENT_OPTIONS = ["0", "5", "10", "15", "20", "25"].map(
  (pct) => ({ value: pct, label: `${pct}%` })
);
